import { render, staticRenderFns } from "./NewUsers.vue?vue&type=template&id=13d01006&scoped=true&"
import script from "./NewUsers.vue?vue&type=script&lang=js&"
export * from "./NewUsers.vue?vue&type=script&lang=js&"
import style0 from "./NewUsers.vue?vue&type=style&index=0&id=13d01006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d01006",
  null
  
)

export default component.exports